<template>
  <div class="list">
    <!-- 빈 목록 -->
    <p class="page__empty" v-if="contentList.length === 0">
      아직 작성한 글이 없어요.<br>첫 번째 기록을 남겨보세요 ✏️
    </p>

    <!-- 글 목록 -->
    <ul class="list__items" v-else>
      <li
        class="list__item"
        v-for="(content, i) in contentList"
        :key="i"
        @click="openDetail(content)"
      >
        <div class="list__item-title">{{ content.title }}</div>
        <div class="list__item-meta">
          <span class="list__item-date">{{ formatDate(content.createDate) }}</span>
          <span class="list__item-tag" v-if="content.tagdata">{{ content.tagdata }}</span>
        </div>
        <p class="list__item-content">{{ content.content }}</p>
      </li>
    </ul>

    <!-- ── 모달 ────────────────────────────────────────── -->
    <div class="modal-backdrop" v-if="modal.show" @click.self="closeModal">
      <div class="modal">

        <!-- 상세 보기 -->
        <template v-if="modal.mode === 'detail'">
          <h3 class="modal__title">{{ modal.data.title }}</h3>
          <div class="modal__meta">
            <span class="list__item-date">{{ formatDate(modal.data.createDate) }}</span>
            <span class="list__item-tag" v-if="modal.data.tagdata">{{ modal.data.tagdata }}</span>
          </div>
          <p class="modal__content">{{ modal.data.content }}</p>
          <div class="modal__actions">
            <button class="btn btn--ghost"    @click="closeModal">닫기</button>
            <button class="btn btn--outline"  @click="startEdit">수정</button>
            <button class="btn btn--danger"   @click="confirmDelete">삭제</button>
          </div>
        </template>

        <!-- 수정 모드 -->
        <template v-if="modal.mode === 'edit'">
          <h3 class="modal__title">글 수정</h3>
          <div class="form">
            <div class="form__item">
              <label class="form__label">제목</label>
              <input class="form__input" type="text" v-model="modal.edit.title" placeholder="제목을 입력하세요" />
            </div>
            <div class="form__item">
              <label class="form__label">내용</label>
              <textarea class="form__textarea" v-model="modal.edit.content" rows="6" placeholder="내용을 입력하세요" />
            </div>
            <div class="form__item">
              <label class="form__label">태그</label>
              <input class="form__input" type="text" v-model="modal.edit.tagdata" placeholder="#태그 (쉼표로 구분)" />
            </div>
          </div>
          <div class="modal__actions">
            <button class="btn btn--ghost"    @click="modal.mode = 'detail'">취소</button>
            <button class="btn btn--primary"  @click="submitEdit">저장</button>
          </div>
        </template>

        <!-- 삭제 확인 -->
        <template v-if="modal.mode === 'delete'">
          <h3 class="modal__title">글을 삭제할까요?</h3>
          <p class="modal__content" style="color:var(--color-text-sub);font-size:1.4rem;">
            삭제된 글은 복구할 수 없어요.
          </p>
          <div class="modal__actions">
            <button class="btn btn--ghost"   @click="modal.mode = 'detail'">취소</button>
            <button class="btn btn--danger"  @click="submitDelete">삭제</button>
          </div>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
import instance from '../axiosInterceptor.js';

export default {
  name: 'listCom',
  data() {
    return {
      contentList: [],
      modal: {
        show: false,
        mode: 'detail',   // 'detail' | 'edit' | 'delete'
        data: {},
        edit: {},
      },
    };
  },
  mounted() {
    this.getListData();
  },
  methods: {
    /** 목록 불러오기 */
    getListData() {
      instance
        .post(process.env.VUE_APP_API_SERVER_URL + '/api/getList', {})
        .then((response) => {
          if (response.status === 200 && response.data.retSuccessFail === 'SUCCESS') {
            this.contentList = response.data.retObj || [];
          }
        })
        .catch((error) => {
          console.error('목록 조회 실패:', error);
        });
    },

    /** 날짜 포맷: 'YYYYMMDDHH24MISS' → 'YYYY.MM.DD' */
    formatDate(val) {
      if (!val || val.length < 8) return val;
      return `${val.slice(0, 4)}.${val.slice(4, 6)}.${val.slice(6, 8)}`;
    },

    /** 상세 모달 열기 */
    openDetail(content) {
      this.modal.data = { ...content };
      this.modal.mode = 'detail';
      this.modal.show = true;
    },

    /** 모달 닫기 */
    closeModal() {
      this.modal.show = false;
      this.modal.data = {};
      this.modal.edit = {};
    },

    /** 수정 모드 진입 */
    startEdit() {
      this.modal.edit = {
        contentid: this.modal.data.contentid,
        title:     this.modal.data.title,
        content:   this.modal.data.content,
        tagdata:   this.modal.data.tagdata,
      };
      this.modal.mode = 'edit';
    },

    /** 수정 제출 */
    submitEdit() {
      if (!this.modal.edit.title || !this.modal.edit.content) {
        alert('제목과 내용을 입력해주세요.');
        return;
      }
      instance
        .post(process.env.VUE_APP_API_SERVER_URL + '/api/updateContent', this.modal.edit)
        .then((response) => {
          if (response.status === 200 && response.data.retSuccessFail === 'SUCCESS') {
            const idx = this.contentList.findIndex(
              (c) => c.contentid === this.modal.edit.contentid
            );
            if (idx !== -1) {
              this.contentList[idx].title   = this.modal.edit.title;
              this.contentList[idx].content = this.modal.edit.content;
              this.contentList[idx].tagdata = this.modal.edit.tagdata;
            }
            this.closeModal();
          } else {
            alert('수정에 실패하였습니다.');
          }
        })
        .catch((error) => {
          console.error('수정 실패:', error);
          alert('수정 중 오류가 발생하였습니다.');
        });
    },

    /** 삭제 확인 모드 */
    confirmDelete() {
      this.modal.mode = 'delete';
    },

    /** 삭제 제출 */
    submitDelete() {
      instance
        .post(process.env.VUE_APP_API_SERVER_URL + '/api/deleteContent', {
          contentid: this.modal.data.contentid,
        })
        .then((response) => {
          if (response.status === 200 && response.data.retSuccessFail === 'SUCCESS') {
            this.contentList = this.contentList.filter(
              (c) => c.contentid !== this.modal.data.contentid
            );
            this.closeModal();
          } else {
            alert('삭제에 실패하였습니다.');
          }
        })
        .catch((error) => {
          console.error('삭제 실패:', error);
          alert('삭제 중 오류가 발생하였습니다.');
        });
    },
  },
};
</script>

<!-- 스타일은 전역 SCSS에서 관리 -->
<!-- _post.scss: .list, .list__item 등 목록 스타일 -->
<!-- _modal.scss: .modal-backdrop, .modal 등 모달 스타일 -->
<!-- _button.scss: .btn, .btn--primary 등 버튼 스타일 -->
<!-- _form.scss: .form, .form__input 등 폼 스타일 -->
